import { CheckboxProps } from "./Checkbox.types";
import "./Checkbox.scss";

import { ReactNode, useMemo } from "react";
import { CheckMark } from "..";
export const Checkbox: React.FC<CheckboxProps> = ({
  label,
  value,
  onCheck,
  disabled = false,
  highlighted = false,
  labelPosition = "left",
}) => {
  /**
   * Holds the displayed label element
   */
  const checkboxLabel: ReactNode = useMemo((): ReactNode => {
    return typeof label === "string" ? (
      <label
        className={[
          "checkbox-component__label",
          highlighted ? "highlighted" : "",
        ].join(" ")}
      >
        {label}
      </label>
    ) : (
      label
    );
  }, [highlighted, label]);

  /**
   * Holds the checkbox element
   */
  const checkboxElement: ReactNode = useMemo((): ReactNode => {
    return value ? (
      <div
        className="checkbox-component__checkbox__checked"
        data-testid="checkbox-checked"
      >
        <CheckMark
          className={[
            "checkbox-component__checkbox__checked__checkmark",
            disabled ? "disabled" : "",
          ].join(" ")}
        />
      </div>
    ) : (
      <div
        data-testid="checkbox-empty"
        className={[
          "checkbox-component__checkbox__empty",
          disabled ? "disabled" : "",
        ].join(" ")}
      />
    );
  }, [disabled, value]);

  /**
   * sorts the label and checkbox according to the selected position
   */
  const positionedElements: ReactNode = useMemo((): ReactNode => {
    switch (labelPosition) {
      case "right":
        return (
          <>
            {checkboxElement}
            {checkboxLabel}
          </>
        );
      case "left":
        return (
          <>
            {checkboxLabel}
            {checkboxElement}
          </>
        );
      case "top":
        return (
          <div className="checkbox-component__position-wrapper">
            {checkboxLabel}
            {checkboxElement}
          </div>
        );
      case "bottom":
        return (
          <div className="checkbox-component__position-wrapper">
            {checkboxElement}
            {checkboxLabel}
          </div>
        );
    }
  }, [checkboxElement, checkboxLabel, labelPosition]);

  return (
    <div
      data-testid="checkbox-component"
      className="checkbox-component__wrapper"
      onClick={() => disabled || onCheck(!value)}
    >
      {positionedElements}
    </div>
  );
};
